import { render, staticRenderFns } from "./fileSelector.vue?vue&type=template&id=c22502c8&scoped=true"
import script from "./fileSelector.vue?vue&type=script&lang=js"
export * from "./fileSelector.vue?vue&type=script&lang=js"
import style0 from "./fileSelector.vue?vue&type=style&index=0&id=c22502c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22502c8",
  null
  
)

export default component.exports